import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { Http } from "@angular/http";
import { timeout } from "rxjs/operators";
import { BulletinSecretService } from "./bulletinSecret.service";
import { WalletService } from "./wallet.service";
import { TransactionService } from "./transaction.service";
import { SettingsService } from "./settings.service";

declare var X25519;

@Injectable()
export class PeerService {
  loading = false;
  mode: any;
  failedSeedPeers: any;
  peerLocked: any;
  failedConfigPeers: any;
  constructor(
    private ahttp: Http,
    public walletService: WalletService,
    public transactionService: TransactionService,
    public bulletinSecretService: BulletinSecretService,
    public settingsService: SettingsService,
    public storage: Storage
  ) {
    this.mode = true;
    this.failedSeedPeers = new Set();
    this.failedConfigPeers = new Set();
  }

  normalizeHost(host) {
    if (!host) return "";
    let h = host.toString().trim();
    if (!h) return "";
    if (h.indexOf("://") < 0) {
      h = "http://" + h;
    }
    return h.replace(/\/+$/, "");
  }

  applyDomain(domain) {
    this.settingsService.remoteSettingsUrl = domain;
    this.settingsService.remoteSettings = {
      baseUrl: domain,
      transactionUrl: domain + "/transaction",
      fastgraphUrl: domain + "/post-fastgraph-transaction",
      graphUrl: domain,
      walletUrl: domain + "/get-graph-wallet",
      websocketUrl: domain + "/websocket",
      loginUrl: domain + "/login",
      registerUrl: domain + "/create-relationship",
      authenticatedUrl: domain + "/authenticated",
      logoData: "",
      identity: {},
    };
  }

  go(host = null, force = false) {
    if (this.peerLocked && !force && !host)
      return new Promise((resolve, reject) => {
        return resolve(null);
      });
    return new Promise((resolve, reject) => {
      var domain = this.normalizeHost(host);
      if (!domain) {
        domain =
          window.location.origin === "http://localhost:8100"
            ? `http://${window.location.hostname}:8005`
            : window.location.origin;
      }
      this.applyDomain(domain);
      return resolve(null);
    })
      .then(() => {
        return this.getConfig(!!host);
      })
      .then(() => {
        this.peerLocked = true;
        return this.storage.set("node", this.settingsService.remoteSettingsUrl);
      });
  }

  getConfig(preserveHost = false) {
    return new Promise((resolve, reject) => {
      const configuredBase = this.settingsService.remoteSettingsUrl;
      this.ahttp
        .get(configuredBase + "/yada-config")
        .pipe(timeout(preserveHost ? 5000 : 1000))
        .subscribe(
          (res) => {
            this.loading = false;
            const remoteSettings = res.json();
            if (preserveHost) {
              // Keep explicit operator host; only fill missing non-URL fields.
              const base = configuredBase;
              this.settingsService.remoteSettings = Object.assign(
                {},
                this.settingsService.remoteSettings || {},
                {
                  baseUrl: base,
                  transactionUrl: base + "/transaction",
                  fastgraphUrl: base + "/post-fastgraph-transaction",
                  graphUrl: base,
                  walletUrl: base + "/get-graph-wallet",
                  websocketUrl:
                    (remoteSettings && remoteSettings.websocketUrl) ||
                    base + "/websocket",
                  loginUrl: base + "/login",
                  registerUrl: base + "/create-relationship",
                  authenticatedUrl: base + "/authenticated",
                  logoData: (remoteSettings && remoteSettings.logoData) || "",
                  identity: (remoteSettings && remoteSettings.identity) || {},
                  restricted:
                    remoteSettings && remoteSettings.restricted
                      ? remoteSettings.restricted
                      : false,
                }
              );
              this.settingsService.remoteSettingsUrl = base;
              resolve(remoteSettings);
              return;
            }
            for (let i = 0; i < Object.keys(remoteSettings).length; i++) {
              try {
                let url = new URL(
                  remoteSettings[Object.keys(remoteSettings)[i]]
                );

                remoteSettings[Object.keys(remoteSettings)[i]] =
                  url.protocol +
                  "//" +
                  (window.location.origin === "http://localhost:8100"
                    ? `${window.location.hostname}:8005`
                    : window.location.host) +
                  (url.pathname === "/" ? "" : url.pathname);
              } catch (e) {
                continue;
              }
            }
            this.settingsService.remoteSettings = remoteSettings;
            resolve(remoteSettings);
          },
          (err) => {
            this.failedConfigPeers.add(this.settingsService.remoteSettingsUrl);
            this.loading = false;
            return reject("config");
          }
        );
    });
  }

  hexToBytes(s) {
    var arr = [];
    for (var i = 0; i < s.length; i += 2) {
      var c = s.substr(i, 2);
      arr.push(parseInt(c, 16));
    }
    return String.fromCharCode.apply(null, arr);
  }

  toHex(byteArray) {
    var callback = function (byte) {
      return ("0" + (byte & 0xff).toString(16)).slice(-2);
    };
    return Array.from(byteArray, callback).join("");
  }
}



// WEBPACK FOOTER //
// ./src/app/peer.service.ts